document.addEventListener("on:cart:add", async (e) => {
  try {
    const detail = e?.detail || {};
    console.log(detail?.properties);
    const monogramEnabled = detail?.properties?.monogram_enabled || detail?.properties?.monogram_color || undefined;
    if (monogramEnabled === "false" || monogramEnabled === undefined) {
      document.querySelector(".js-cart-drawer").open();
      return; // nothing to bundle
    }

    const ADDON_VARIANT_ID = 45025779220666; // your add-on variant
    const MIRROR_QTY = true; // set to false if add-on qty should always be 1

    // 1) Get current cart
    const cart = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
    }).then((r) => r.json());

    // 2) Locate the just-added "main" line
    // Prefer matching by key if your event provides it; otherwise fallback by variant + properties.
    const findMain = () => {
      // If theme includes the line item key in the event:
      if (detail.key) return cart.items.find((i) => i.key === detail.key);

      // Fallback: find the most recent line matching variant + properties
      // We reverse iterate to bias towards the newest lines
      const props = detail.properties || {};
      for (let i = cart.items.length - 1; i >= 0; i--) {
        const it = cart.items[i];
        if (detail.variant_id && it.variant_id !== detail.variant_id) continue;

        // Shallow compare relevant properties (ignore internal keys)
        let same = true;
        for (const [k, v] of Object.entries(props)) {
          if (k.startsWith("_")) continue;
          if ((it.properties?.[k] ?? "") != (v ?? "")) {
            same = false;
            break;
          }
        }
        if (same) return it;
      }
      return null;
    };

    const main = findMain();
    if (!main) {
      console.warn("Main line not found; skipping bundle add.");
      return;
    }

    const removeItem = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: main.key, quantity: 0 }),
    });

    if (!removeItem.ok) throw new Error("Failed to remove main item");

    const mainProps = {
      ...(main.properties || {}),
      _is_addon: "false",
    };
    // 4) Add the add-on with the SAME bundle id
    const addonQty = MIRROR_QTY ? Number(main.quantity) : 1;

    const addonPayload = {
      items: [
        {
          id: ADDON_VARIANT_ID,
          quantity: addonQty,
          properties: {
            ...Object.fromEntries(
              Object.entries(main.properties || {}).filter(([key]) =>
                key.toLowerCase().includes("monogram"),
              ),
            ),
            _bundle_id: main.properties._bundle_id,
            _is_addon: "true",
            _linked_to: main.key,
          },
        },
        {
          id: main.variant_id,
          quantity: main.quantity,
          properties: mainProps,
          ...(main.selling_plan_allocation
            ? { selling_plan: main.selling_plan_allocation.selling_plan_id }
            : {}),
        },
      ],
    };
    const addAddon = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(addonPayload),
    });

    if (!addAddon.ok) throw new Error("Failed to add bundled add-on");

    document.dispatchEvent(new CustomEvent("on:cart:change"));
    setTimeout(() => {
      document.querySelector(".js-cart-drawer").open();
    }, 1000);
  } catch (err) {
    console.error("Bundle add error:", err);
  }
});

// (async function cartBundleSync() {
//   const $doc = document;

//   const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' }}).then(r => r.json());

//   async function removeBundleById(bundleId) {
//     const cart = await getCart();
//     const group = cart.items.filter(i => (i.properties?._bundle_id || '') === bundleId);
//     // Remove all lines in parallel
//     await Promise.all(group.map(i =>
//       fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//         body: JSON.stringify({ id: i.key, quantity: 0 })
//       })
//     ));
//   }

//   // Intercept remove clicks
//   $doc.addEventListener('click', async (e) => {
//     const btn = e.target.closest('.quantity-down');
//     if (!btn) return;

//     e.preventDefault();

//     const bundle = btn.dataset.bundle || '';
//     const isAddon = (btn.dataset.isAddon || 'false') === 'true';
//     const key = btn.dataset.key;

//     try {
//       if (bundle) {
//         // If the clicked line is MAIN or ADDON, remove the whole bundle
//         await removeBundleById(bundle);
//       } else if (key) {
//         // Unbundled fallback—remove just that line
//         await fetch('/cart/change.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//           body: JSON.stringify({ id: key, quantity: 0 })
//         });
//       }

//       // Refresh your drawer/page (adjust to your theme)
//       document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { openDrawer: true } }));
//       document.dispatchEvent(new CustomEvent('cart:updated'));
//     } catch (err) {
//       console.error('Bundle remove failed', err);
//     }
//   }, { capture: true }); // capture helps beat theme handlers

//   // Optional: keep addon quantity in sync with main
//   $doc.addEventListener('change', async (e) => {
//     const input = e.target.closest('[data-cart-qty]');
//     if (!input) return;

//     const qty = Math.max(0, parseInt(input.value || '0', 10) || 0);
//     const bundle = input.dataset.bundle || '';
//     const isAddon = (input.dataset.isAddon || 'false') === 'true';

//     if (!bundle) return;

//     try {
//       const cart = await getCart();
//       const lines = cart.items.filter(i => (i.properties?._bundle_id || '') === bundle);

//       const main = lines.find(i => String(i.properties?._is_addon || 'false') !== 'true');
//       const addons = lines.filter(i => String(i.properties?._is_addon || 'false') === 'true');

//       // If user changed MAIN, mirror qty to add-ons.
//       // If user changed ADDON, snap it back to main's qty.
//       const targetQty = isAddon ? (main?.quantity ?? qty) : qty;

//       await Promise.all(addons.map(i =>
//         fetch('/cart/change.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//           body: JSON.stringify({ id: i.key, quantity: targetQty })
//         })
//       ));

//       // If main was changed via this input, also persist it (some themes already did)
//       if (!isAddon) {
//         await fetch('/cart/change.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//           body: JSON.stringify({ id: input.dataset.key, quantity: targetQty })
//         });
//       }

//       document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { openDrawer: true } }));
//       document.dispatchEvent(new CustomEvent('cart:updated'));
//     } catch (err) {
//       console.error('Bundle qty sync failed', err);
//     }
//   }, { capture: true });

//   // Safety net: after any cart update, purge orphan add-ons (no main in their bundle)
//   document.addEventListener('cart:updated', async () => {
//     try {
//       const cart = await getCart();
//       const bundles = new Map(); // bundleId -> { hasMain, addons: [] }
//       for (const it of cart.items) {
//         const bid = it.properties?._bundle_id;
//         if (!bid) continue;
//         const isAddon = String(it.properties?._is_addon || 'false') === 'true';
//         const b = bundles.get(bid) || { hasMain: false, addons: [] };
//         if (isAddon) b.addons.push(it); else b.hasMain = true;
//         bundles.set(bid, b);
//       }
//       const orphans = [];
//       bundles.forEach((b) => { if (!b.hasMain) orphans.push(...b.addons); });
//       if (orphans.length) {
//         await Promise.all(orphans.map(i =>
//           fetch('/cart/change.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//             body: JSON.stringify({ id: i.key, quantity: 0 })
//           })
//         ));
//         document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { openDrawer: true } }));
//       }
//     } catch (e) {
//       console.warn('Orphan cleanup skipped', e);
//     }
//   });
// })();
